import { useState, useEffect, useRef, useMemo } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import emailjs from "emailjs-com"; // <–– emailjs käytössä
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import contactVideo from "../../assets/contactVideo.mp4";
import RentalDateSelector from "../../components/RentalDateSelector/RentalDateSelector";
import { useBooking } from "../../context/BookingContext";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import { Link } from "react-router-dom";
import Confetti from "react-confetti";
import RecaptchaField from "../../components/RecaptchaField/RecaptchaField";
import ContactPageHelmetComponent from "./ContactPageHelmetComponent";
import CheckoutForm from "../../components/CheckoutForm/CheckoutForm";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
// import { useCallback } from "react";
const libraries = ["places"];

// Etsitään "peräkärry" nimen/slugin perusteella
const trailerKeywords = [
  "peräkärry",
  "perakarry",
  "traileri",
  "hirvi 350",
  "kuomukärry",
  "kärry",
  "karry",
];

/**
 * Yhdistetty laskentafunktio
 * Laskee vuokrauksen kokonaispäivät (pyöristää ylöspäin, jos vuokraus ylittää täyden vuorokauden edes tunnilla)
 */
const calculateRentalPrice = (start, end, pricePerDay, quantity, isTrailer = false) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffInMs = endDate - startDate;
  if (isTrailer) {
    // Trailerille: pyöristetään aina kokonaisiksi päiviksi
    const hours = diffInMs / (1000 * 60 * 60);
    const days = Math.ceil(hours / 24);
    return days * pricePerDay * (quantity || 1);
  } else {
    const msInDay = 1000 * 60 * 60 * 24;
    const days = Math.ceil(diffInMs / msInDay) || 1;
    return days * pricePerDay * (quantity || 1);
  }
};

// Näyttää päivämäärän + kellonajan, esim. 08.04.2025 klo 09.00
const formatDateTime = (dateStr) => {
  return new Intl.DateTimeFormat("fi-FI", {
    timeZone: "Europe/Helsinki",
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(dateStr));
};

// Näyttää vain päivämäärän, esim. 08.04.2025
const formatDateOnly = (dateStr) => {
  return new Intl.DateTimeFormat("fi-FI", {
    timeZone: "Europe/Helsinki",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(dateStr));
};


const Contactpage = () => {
  // AOS
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // *******************************
  //  1) ENV-muuttujat + ASETUKSET
  // *******************************
  const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;
  const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const EMAILJS_TEMPLATE_ID_OWNER = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_OWNER;
  const EMAILJS_TEMPLATE_ID_CUSTOMER = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CUSTOMER;
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
  const HOME_ADDRESS = process.env.REACT_APP_HOME_ADDRESS || "Näsiätie 2, Kerava";
  const VARAUSMAKSU = 50;
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  console.log("STRIPE PROMISE:", stripePromise);
  // *******************************
  //  2) OSTOSKORI & PERÄKÄRRY-LOGIIKKA
  // *******************************
  // Yhdistetään tarvittavat tilat BookingContextista
  const { trailerPickupTime, setTrailerPickupTime, selectedDates, setSelectedDates } = useBooking();
  const [cart, setCart] = useState([]);
  const [showConfetti, setShowConfetti] = useState(false);
  const [deliveryOption, setDeliveryOption] = useState("pickup");
  const [userId, setUserId] = useState(null);
  // Kuljetus
  // const [maksuSuoritettu, setMaksuSuoritettu] = useState(false);

  const [distance, setDistance] = useState(null);
  const [travelCost, setTravelCost] = useState(null);
  const needsTransport = useMemo(() => deliveryOption === "delivery", [deliveryOption]);


  // Radiovalinta: varaus vs. pelkkä viesti
  const [autoMessageOption, setAutoMessageOption] = useState("reservation");

  // Lisäkenttä: vetoauton rekisterinumero
  const [trailerLicensePlate, setTrailerLicensePlate] = useState("");

  // Määritellään hasTrailer, joka etsii trailer-tuotteen korista
  const hasTrailer = useMemo(() => {
    return cart.some((item) => {
      const name = item.name?.toLowerCase() || "";
      const slug = item.slug?.toLowerCase() || "";
      return trailerKeywords.some(
        (keyword) => name.includes(keyword) || slug.includes(keyword)
      );
    });
  }, [cart]);

      // Laskee korin vuokra- ja kuljetussumman yhteen
      // const calculateTotal = useCallback(() => {
      //   const rentalTotal = cart.reduce((sum, item) => {
      //     const isTrailerItem = item.slug?.toLowerCase().includes("hirvi");
      //     return sum + calculateRentalPrice(
      //       selectedDates.startDate,
      //       selectedDates.endDate,
      //       item.price,
      //       item.quantity,
      //       isTrailerItem
      //     );
      //   }, 0);
      //   const transport = needsTransport && travelCost
      //     ? parseFloat(travelCost)
      //     : 0;
      //   return rentalTotal + transport;
      // }, [cart, selectedDates, travelCost, needsTransport]);

  const hasDevices = useMemo(() => {
    return cart.some((item) => {
      const name = item.name?.toLowerCase() || "";
      const slug = item.slug?.toLowerCase() || "";
  
      // Tarkistetaan ettei ole traileri – jos ei ole, kyseessä on laite
      const isTrailer = trailerKeywords.some((kw) => name.includes(kw) || slug.includes(kw));
      return !isTrailer;
    });
  }, [cart]);
  

  // Ladataan kori localStoragesta
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("rentalCart")) || [];
    const updatedCart = storedCart.map((item) => ({
      ...item,
      price: parseFloat(item.price) || 0,
      quantity: item.quantity ? Number(item.quantity) : 1,
    }));
    setCart(updatedCart);
  }, []);

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    const parsed = parseInt(storedUserId, 10);
    if (!isNaN(parsed)) {
      setUserId(parsed);
    } else {
      console.warn("userId puuttuu tai ei ole numero:", storedUserId);
    }
  }, []);
  

  // Kuunnellaan "cartUpdated" -eventtiä
  useEffect(() => {
    const handleCartUpdate = () => {
      const newCart = JSON.parse(localStorage.getItem("rentalCart")) || [];
      const cartWithNumbers = newCart.map((item) => ({
        ...item,
        price: parseFloat(item.price) || 0,
        quantity: item.quantity ? Number(item.quantity) : 1,
      }));
      setCart(cartWithNumbers);
    };
    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);
  

  // Päivämäärien alustus localStoragesta
  useEffect(() => {
    const savedDates = JSON.parse(localStorage.getItem("selectedBookingDates"));
    if (savedDates && savedDates.startDate && savedDates.endDate) {
      setSelectedDates(savedDates);
    }
  }, [setSelectedDates]);

  useEffect(() => {
    if (deliveryOption === "pickup" && !hasTrailer && needsTransport !== false) {
      setDistance(null);
      setTravelCost(null);
    }
  }, [deliveryOption, hasTrailer, needsTransport]);
  
  
  
  // Aseta trailerPickupTime käyttäen selectedDates.startDate (muuntaa ajan "23.00" -> "23:00")
  useEffect(() => {
    if (selectedDates?.startDate) {
      const date = new Date(selectedDates.startDate);
      const raw = date.toLocaleTimeString("fi-FI", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Europe/Helsinki",
      });
      const formatted = raw.replace(".", ":");
      setTrailerPickupTime(formatted);
    }
  }, [selectedDates?.startDate, setTrailerPickupTime]);

  // Laske trailerin vuokrauksen aloitusaika ja palautusaika
  useEffect(() => {
    if (hasTrailer && selectedDates.startDate && trailerPickupTime) {
      const [h, m] = trailerPickupTime.split(":");
      const baseDate = new Date(selectedDates.startDate);
      const pickupDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate(),
        Number(h),
        Number(m),
        0
      );
     
      const returnDate = new Date(pickupDate);
      returnDate.setDate(returnDate.getDate() + 1);

    }
  }, [hasTrailer, selectedDates.startDate, trailerPickupTime]);

  // *******************************
  //  3) LOMAKKEEN TILAT
  // *******************************
  const [nimi, setNimi] = useState("");
  const [sahkoposti, setSahkoposti] = useState("");
  const [puhelinnumero, setPuhelinnumero] = useState("");
  const [emailError, setEmailError] = useState("");
  

  const validateEmail = (value) => {
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    if (!emailPattern.test(value)) {
      setEmailError("Anna kelvollinen sähköpostiosoite");
    } else {
      setEmailError("");
    }
  };
  

const [phoneError, setPhoneError] = useState("");

const validatePhone = (value) => {
  const phonePattern = /^[0-9\s\-+()]{7,20}$/;
  if (!phonePattern.test(value)) {
    setPhoneError("Anna kelvollinen puhelinnumero");
  } else {
    setPhoneError("");
  }
};

  const [tapahtumapaikka, setTapahtumapaikka] = useState("");
  const [viesti, setViesti] = useState("");
  const [recaptchaRentalValue, setRecaptchaRentalValue] = useState(null);
  const [formError, setFormError] = useState(null);
  const [deliveryAddress, setDeliveryAddress] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [maksuSuoritettu, setMaksuSuoritettu] = useState(false);

  const cleanAddress = deliveryAddress.trim();
  const deliveryRequired =
  (hasTrailer && deliveryOption === "delivery") ||
  (hasDevices && deliveryOption === "delivery");

  const isValidAddress =
    cleanAddress && cleanAddress.length > 5 && cleanAddress.includes(" ");
  
  // *******************************
  //  4) GOOGLE AUTOCOMPLETE
  // *******************************
  const autocompleteRef = useRef(null);
  const recaptchaRef = useRef(null);
  const deliveryRef = useRef(null);
  const autocompleteOptions = {
    componentRestrictions: { country: "fi" },
  };

  // *******************************
  //  5) MUUT EFFECTIT & APUFUNKTIOT
  // *******************************
  // Näytetään navbar (jos sellaista on)
  useEffect(() => {
    const navbar = document.querySelector("navbar");
    if (navbar) {
      navbar.style.display = "block";
    }
  }, []);
  

  useEffect(() => {
    if (cart.length === 0) {
      setDeliveryAddress("");
      setDistance(null);
      setTravelCost(null);
      // ÄLÄ nollaa deliveryOption, jätetään käyttäjän valinta voimaan
    }
  }, [cart]);
  

  const shouldUseTrailerForTransport = (cart) => {
    const excludedItems = ["mikrofoni", "mikrofoniteline", "kamera"];
    const count = cart.reduce((acc, item) => {
      const name = item.name?.toLowerCase() || "";
      const slug = item.slug?.toLowerCase() || "";
      const isExcluded = excludedItems.some((ex) =>
        name.includes(ex) || slug.includes(ex)
      );
      return isExcluded ? acc : acc + (item.quantity || 1);
    }, 0);
  
    return count > 5;
  };
  
// komponentissa ennen returnia
const deviceCount = cart
  .filter(item => {
    const name = item.name?.toLowerCase() || "";
    const slug = item.slug?.toLowerCase() || "";
    return !trailerKeywords.some(kw => name.includes(kw) || slug.includes(kw));
  })
  .reduce((sum, item) => sum + (item.quantity || 1), 0);

// ja JSX:ssä
{needsTransport && distance && deviceCount > 5 && (
  <p className="text-yellow-300 text-sm mt-2 font-customFont1">
    🚚 Koska vuokrattuja laitteita on yli 5, kuljetus vaatii peräkärryn.
    Kärryn käyttömaksu (20€ / suunta) on lisätty hintaan.
  </p>
)}

  
  // Google Distance
  const calculateDistance = (destinationLocation) => {
    const trailerNeeded = shouldUseTrailerForTransport(cart);
  
    const service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [HOME_ADDRESS],
        destinations: [destinationLocation],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
      },
      (response, status) => {
        if (status === "OK") {
          const element = response.rows[0].elements[0];
          if (element.status === "OK") {
            const distanceInKm = element.distance.value / 1000;
            setDistance(distanceInKm);
  
            // Kärryn kanssa 0.69/km, muuten 0.59/km
            const meno = distanceInKm * (trailerNeeded ? 0.69 : 0.59);
            const paluu = distanceInKm * 0.59;
            const trailerFee = trailerNeeded ? 40 : 0; // 20€/suunta
  
            const totalCost = meno + paluu + trailerFee;
            setTravelCost(totalCost.toFixed(2));
          } else {
            setFormError(`Matkan laskeminen epäonnistui: ${element.status}`);
            setDistance(null);
            setTravelCost(null);
          }
        } else {
          setFormError(`Matkan laskeminen epäonnistui. Google API status: ${status}`);
          setDistance(null);
          setTravelCost(null);
        }
      }
    );
  };
  
  // Autocomplete "deliveryAddress"
  const onPlaceChanged = () => {
    if (deliveryRef.current) {
      const place = deliveryRef.current.getPlace();
      if (place && place.geometry) {
        setDeliveryAddress(place.formatted_address);
        calculateDistance(place.geometry.location);
      }
    }
  };

// *******************************
//  6) LOMAKKEEN LÄHETYS
// *******************************

const handleFormSubmit = async (e) => {

  if (!recaptchaRentalValue) {
    toast.warning("Vahvista että et ole botti reCAPTCHA-testillä.");
    return;
  }
   
  e.preventDefault();
  setFormError(null);

// (A) PELKKÄ VIESTI
if (autoMessageOption === "message") {
  const missing = [];
  if (!nimi) missing.push("Nimi");
  if (!sahkoposti) missing.push("Sähköposti");
  if (!puhelinnumero) missing.push("Puhelinnumero");
  if (!viesti) missing.push("Viestisi");

  if (missing.length > 0) {
    toast.warning(`Puuttuvat kentät: ${missing.join(", ")}`);
    return;
  }

  const templateParamsOwner = {
    user_name: nimi,
    user_email: sahkoposti,
    user_phone: puhelinnumero,
    place: tapahtumapaikka || deliveryAddress || "", // tämä rivi lisää tapahtumapaikan
    greeting_text: `Hei!`,
    info_text: `Olet saanut uuden viestin lomakkeen kautta.`,
    user_message_section: viesti.replace(/\n/g, "<br/>"),
    
    // Tyhjennetään kaikki muut kentät
    cart_summary: "",
    total_price: "",
    remaining_amount: "",
    reservation_fee_line: "",
    trailer_info_section: "",
    payment_info_section: "",
    info_section: "",
    delivery_info_section: "",
    closing_text: "",
    logo_url: "https://spiderlegsproductions.com/wp-content/uploads/2025/03/new_logo.webp"
  };

  try {
    const ownerResult = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_OWNER,
      templateParamsOwner,
      EMAILJS_USER_ID
    );

    if (ownerResult.status === 200) {
      toast.success("Viestisi on lähetetty! Otamme sinuun pian yhteyttä.");
      setNimi("");
      setSahkoposti("");
      setPuhelinnumero("");
      setViesti("");
    } else {
      toast.error("Viestin lähetys epäonnistui.");
    }
  } catch (error) {
    console.error("Virhe viestin lähetyksessä:", error);
    toast.error("Jotain meni pieleen.");
  }

  return;
}


  // (B) VARAUS (laitteet/peräkärry)
  let missingFields = [];
  if (!nimi) missingFields.push("Nimi");
  if (!sahkoposti) missingFields.push("Sähköposti");
  if (!puhelinnumero) missingFields.push("Puhelinnumero");
  if (!selectedDates?.startDate) missingFields.push("Aloituspäivä");
  if (!selectedDates?.endDate) missingFields.push("Loppupäivä");
  if (!cart?.length) missingFields.push("Ostoskorisi on tyhjä");
  if (hasTrailer && !trailerLicensePlate.trim()) missingFields.push("Rekisterinumero");
  // Kuljetus?
  if (deliveryRequired && !isValidAddress) missingFields.push("Toimitusosoite");
  if (needsTransport && (!distance || !travelCost)) {
    toast.error("Kuljetusvalinta tehty, mutta matkaa ei ole laskettu.");
    return;
  }

  if (missingFields.length > 0) {
    toast.warning(`Puuttuvat kentät: ${missingFields.join(", ")}`);
    return;
  }

  // Tarkista päivämäärien kelvollisuus
  const isAvailable = await checkAvailability();
  if (!isAvailable) return;

  // Tallenna backendiin tms.
  const formData = {
    nimi,
    sahkoposti,
    puhelinnumero,
    tapahtumapaikka,
    deliveryAddress,
    trailerLicensePlate,
    start_date: selectedDates.startDate,
    end_date: selectedDates.endDate,
    cart: cart.map((item) => ({ id: item.id, quantity: item.quantity })),
    viesti,
    userId: userId ? parseInt(userId) : null, // 🔥 TÄSSÄ LISÄTÄÄN userId
  };

  // Tyhjennä localStorage
  localStorage.removeItem("selectedBookingDates");
  localStorage.removeItem("rentalCart");
  localStorage.removeItem("trailerPickupTime");

  try {
    const resp = await fetch("https://spiderlegsproductions.com/api/save_reservation.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    const result = await resp.json();
    if (!result.success) {
      toast.error(result.message || "Tallennus epäonnistui.");
      return;
    }

    // Jos varaus onnistui, voidaan nyt käyttää varausID:tä
const confirm_button_html = hasDevices && !hasTrailer
? `<a href="https://spiderlegsproductions.com/confirm_reservation?varausID=${result.varausID}" 
      style="background-color: #00cc88; color: #fff; padding: 12px 24px; border-radius: 8px; text-decoration: none; font-weight: bold;">
      ✅ Vahvista varaus
   </a><br/><br/>`
: "";


    // Lasketaan hinnat
    const rentalSums = cart.reduce((acc, item) => {
      const isTrailerItem = item.slug?.toLowerCase().includes("hirvi");
      const itemCost = calculateRentalPrice(
        selectedDates.startDate,
        selectedDates.endDate,
        item.price,
        item.quantity,
        isTrailerItem
      );
      if (isTrailerItem) acc.trailerTotal += itemCost;
      else acc.deviceTotal += itemCost;
      return acc;
    }, { trailerTotal: 0, deviceTotal: 0 });

    const reservationFee = rentalSums.deviceTotal > 100 ? VARAUSMAKSU : 0;
    const totalCustomerPrice = rentalSums.trailerTotal + rentalSums.deviceTotal;
    const remainingAmount = totalCustomerPrice - reservationFee;
    
    // Tämä lisätään tähän:
    const reservation_fee_line = reservationFee > 0 && hasDevices && !hasTrailer
      ? `<li><strong>Varausmaksu:</strong> ${reservationFee.toFixed(2)} €</li>`
      : "";

    const formattedStart = hasTrailer
      ? formatDateTime(selectedDates.startDate)
      : formatDateOnly(selectedDates.startDate);

    const formattedEnd = hasTrailer
      ? formatDateTime(selectedDates.endDate)
      : formatDateOnly(selectedDates.endDate);

    // 5) Rakennetaan placeholder-osuudet:
    // Peräkärry
    const trailer_info_section = hasTrailer 
      ? `
        <h3 style="color: #00ffcc; border-bottom: 1px solid #555;">🚛 Peräkärryn tiedot</h3>
        <ul style="padding-left: 20px;">
          <li><strong>Vetoauton rekisterinumero:</strong> ${trailerLicensePlate}</li>
          <li><strong>Nouto:</strong> ${formattedStart}</li>
          <li><strong>Palautus:</strong> ${formattedEnd}</li>
        </ul>
      `
      : "";

    // Logo
    const logo_url = hasTrailer
      ? "https://spiderlegsproductions.com/wp-content/uploads/2025/04/perakarry.png"
      : hasDevices
        ? "https://spiderlegsproductions.com/wp-content/uploads/2025/04/laitteidenvaraus.png"
        : "https://spiderlegsproductions.com/wp-content/uploads/2025/03/new_logo.webp";

    // Tervehdys, info, lopputeksti
    const greeting_text = `Hei ${nimi},`;
    const info_text = hasTrailer
      ? "Kiitos peräkärryvarauksestasi! Alta löydät kaikki vuokraukseen liittyvät tiedot ja ohjeet."
      : "Kiitos laitevarauksestasi! Tässä yhteenveto vuokraamistasi laitteista ja muut tärkeät ohjeet.";
    const closing_text = hasTrailer
      ? "Jos herää kysymyksiä kärryn suhteen tai tarvitset lisätietoa, ota rohkeasti yhteyttä."
      : "Jos haluat lisätä tilaukseesi muita laitteita tai palveluita tai sinulla on kysyttävää, olethan meihin yhteydessä.";

    // Maksutiedot vain kärrylle
    const payment_info_section = hasTrailer
      ? `
        <h3 style="color: #ff8c00; border-bottom: 1px solid #555;">💳 Maksutiedot</h3>
        <ul style="padding-left: 20px;">
          <li>Maksunsaaja: Arttu Stenius</li>
          <li><strong>Tilinumero:</strong> NORDEA FI21 1470 3501 1362 98</li>
          <li><strong>MobilePay:</strong> 044 351 92 65</li>
        </ul>
        <p>📌 <strong>Laitathan maksun viestikenttään: Nimesi, peräkärryn vuokraus ja päivämäärä (esim. "Matti Meikäläinen, kärry 12.5.</p>
      `
      : "";

    // Tiedoksi-osio
    let info_section = "";
    if (hasTrailer) {
      info_section = `
        <h3 style="color: #ffa500;">📌 Tiedoksi</h3>
        <p>
         Maksun tulee näkyä tilillämme ennen vuokrauksen alkua. Jos näin ei ole, vuokraajalla on oltava esittää maksukuitti noudon tai toimituksen yhteydessä.<br><br>Kun maksu on suoritettu, saat kärryn tarkan osoitteen ja avainkaapin koodin. Kärry sijaitsee yksityisalueella Saviolla ja alue on kameravalvottu.<br><br>Vetoauton rekisterinumeron on täsmättävä varauksen tietoihin.
        </p>
      `;
    } else if (hasDevices) {
      info_section = `
        <h3 style="color: #ffa500;">📌 Tiedoksi</h3>
    <p>
        Laitteet on nyt alustavasti varattu sinulle. Vahvista varaus vastaamalla tähän sähköpostiin mahdollisimman pian. 
        Varaus poistuu automaattisesti järjestelmästä, ellei sitä vahvisteta 6 tunnin kuluessa.
      </p>

      <p>
        Jos laitteiden vuokrahinta ylittää 100 €, käytössämme on 50 € suuruinen <strong>varausmaksu</strong>. 
        Varausmaksu vähennetään loppusummasta.
      </p>

      <h4 style="margin-top: 16px; color: #ff8c00;">💳 Maksutiedot</h4>
      <ul style="padding-left: 20px; color: #f0f0f0;">
        <li>Maksunsaaja: Arttu Stenius</li>
        <li><strong>Tilinumero:</strong> NORDEA FI21 1470 3501 1362 98</li>
        <li><strong>MobilePay:</strong> 044 351 92 65</li>
      </ul>
      <p>📌 <strong>Viestikenttään:</strong> nimesi ja varauspäivämäärä (esim. "Matti Meikäläinen, varausmaksu 12.5.")</p>

      <p style="margin-top: 16px;">
        Loppumaksusta sovitaan yleensä laitteiden noudon tai toimituksen yhteydessä.
      </p>
      `;
    }

    // Kuljetus
    const delivery_info_section = (deliveryRequired && distance && travelCost)
      ? `
        <h3 style="color: #00FA9A;">🚚 Kuljetus</h3>
        <ul style="padding-left: 20px;">
          <li><strong>Toimitusosoite:</strong> ${deliveryAddress}</li>
          <li><strong>Etäisyys:</strong> ${distance.toFixed(1)} km</li>
          <li><strong>Kuljetuskustannus:</strong> ${travelCost} €</li>
        </ul>
      `
      : "";

    // Viesti
    const user_message_section = viesti
      ? viesti.replace(/\n/g, "<br/>")
      : "";

    // Kootaan parametrit (asiakas)
    const templateParamsCustomer = {
      user_name: nimi,
      user_email: sahkoposti, // ← TÄMÄ puuttuu virheessäsi
      
      cart_summary: cart.map((i) => `${i.name} (x${i.quantity})`).join(", "),
      total_price: totalCustomerPrice.toFixed(2),
      remaining_amount: remainingAmount.toFixed(2),

      // Ehdolliset HTML-osiot
      reservation_fee_line,
      trailer_info_section,
      payment_info_section,
      info_section,
      delivery_info_section,
      user_message_section,

      // Tekstiosiot
      greeting_text,
      info_text,
      confirm_button_html,
      closing_text,
      logo_url,
    };

    // Omistajalle
    const templateParamsOwner = {
      ...templateParamsCustomer,
      user_phone: puhelinnumero,
      // Omistajalle voi laittaa halutun pohjan
    };

    // Lähetä
    const [customerRes, ownerRes] = await Promise.all([
      emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID_CUSTOMER,
        templateParamsCustomer,
        EMAILJS_USER_ID
      ),
      emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID_OWNER,
        templateParamsOwner,
        EMAILJS_USER_ID
      ),
    ]);

    if (customerRes.status === 200 && ownerRes.status === 200) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);

      toast.success("Varausvahvistus lähetetty! Tarkista sähköpostisi.", {
        autoClose: 6000,
      });

      // Tyhjennä lomake
      setNimi("");
      setSahkoposti("");
      setPuhelinnumero("");
      setTapahtumapaikka("");
      setViesti("");
      setCart([]);
      localStorage.removeItem("rentalCart");
      window.dispatchEvent(new Event("cartUpdated"));
    } else {
      toast.error("Sähköpostin lähetys epäonnistui.");
    }
  } catch (error) {
    console.error("Virhe:", error);
    toast.error("Tietojen lähettäminen epäonnistui.");
  }
};

  const checkAvailability = async () => {
    let errors = [];
  
    // 1. Ostoskori tyhjä
    if (!Array.isArray(cart) || cart.length === 0) {
      errors.push("Valitse ensin vuokrattavat tuotteet.");
    }
  
    // 2. Päivämäärät puuttuvat
    if (!selectedDates.startDate || !selectedDates.endDate) {
      errors.push("Syötä molemmat päivämäärät.");
    }
  
    // 3. Aloituspäivä myöhäisempi kuin loppupäivä
    if (
      selectedDates.startDate &&
      selectedDates.endDate &&
      new Date(selectedDates.startDate) > new Date(selectedDates.endDate)
    ) {
      errors.push("Aloituspäivä ei voi olla loppupäivää myöhemmin.");
    }
  
    // 4. Valinnainen: estetään menneisyyteen varaaminen
    const now = new Date();
    if (
      selectedDates.startDate &&
      new Date(selectedDates.startDate).setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0)
    ) {
      errors.push("Aloituspäivä ei voi olla menneisyydessä.");
    }
  
    // Jos virheitä löytyi, näytetään ne
    if (errors.length > 0) {
      setFormError(errors.join(" "));
      return false;
    }
  
    return true;
  };
  
  // Poistetaan tuote korista
const handleRemoveFromCart = (index) => {
  try {
    const updatedCart = [...cart];
    const removedItem = updatedCart.splice(index, 1)[0];
    setCart(updatedCart);
    localStorage.setItem("rentalCart", JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated"));
    toast.info(`${removedItem.name} on poistettu vuokrauskorista.`);
  } catch (error) {
    console.error("Tuotteen poistaminen epäonnistui:", error);
    toast.error("Tuotteen poistaminen epäonnistui. Yritä myöhemmin.");
  }
};

  // *******************************
  //  7) RENDERÖINTI
  // *******************************

  return (
    <>
    <ContactPageHelmetComponent />

    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={libraries}>
      {showConfetti && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={800}
          recycle={false}
        />
      )}

      <div className="relative min-h-screen w-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover min-h-screen"
        >
          <source src={contactVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="relative min-h-screen flex flex-col justify-center items-center pt-20 py-10">
          <motion.div
            className="relative bg-black/60 shadow-lg p-6 max-w-6xl w-full mx-auto min-h-[700px]"
            data-aos="fade-in"
            layout
          >
            <h1
              className="font-customFont2 text-shadow-xxl text-left text-primary dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2]"
              data-aos="fade-in"
              data-aos-duration="1500"
            >
              Varaus ja yhteydenotto
            </h1>

              {/* Radiovalinta: varaus / viesti */}
              <div className="space-y-2 mb-4">
                    <p className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl font-bold">
                      Valitse, haluan..
                    </p>
                    <div className="flex items-center space-x-4">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="autoMessageOption"
                          value="reservation"
                          checked={autoMessageOption === "reservation"}
                          onChange={() => setAutoMessageOption("reservation")}
                          className="form-radio text-primary"
                        />
                        <span className="ml-2 font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light">
                          Tehdä laitevarauksen.
                        </span>
                      </label>
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="autoMessageOption"
                          value="message"
                          checked={autoMessageOption === "message"}
                          onChange={() => setAutoMessageOption("message")}
                          className="form-radio text-primary"
                        />
                        <span className="ml-2 font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light">
                          Lähettää viestin.
                        </span>
                      </label>
                    </div>
                  </div>

            {needsTransport && distance && cart && (() => {
              const deviceCount = cart.filter((item) => {
                const name = item.name?.toLowerCase() || "";
                const slug = item.slug?.toLowerCase() || "";
                return !trailerKeywords.some((kw) => name.includes(kw) || slug.includes(kw));
              }).reduce((sum, item) => sum + (item.quantity || 1), 0);
            
              if (deviceCount > 5) {
                return (
                  <p className="text-yellow-300 text-sm mt-2 font-customFont1">
                    🚚 Koska vuokrattuja laitteita on yli 5, kuljetus vaatii peräkärryn.
                    Kärryn käyttömaksu (20€ / suunta) on lisätty hintaan.
                  </p>
                );
              }
              return null;
            })()}

            {formError && (
              <p className="text-red-500 text-sm mt-2">{formError}</p>
            )}

            <p className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light pb-4">
              {autoMessageOption === "message" ? (
                <>
                Olipa kyse palautteesta, palveluihin liittyvistä kysymyksistä tai yhteistyöehdotuksesta, älä epäröi ottaa yhteyttä.
                  <br />
                </>
              ) : hasTrailer ? (
                <>
                  Täytä alla oleva lomake vuokrataksesi <strong>HIRVI 350 -kuomukärryn</strong>.
                  <br />
                  Saat sähköpostiisi yhteenvedon ja ohjeet varauksen vahvistamiseen sekä noutoon.
                  <br />
                  Halutessasi voit myös <strong>valita kärryn toimituksen</strong> suoraan haluamaasi osoitteeseen.
                </>
              ) : (
                <>
                  Täytä alla oleva lomake varataksesi vuokrauskorin sisällön.
                  <br />
                  Sen jälkeen saat yhteenvedon sähköpostiisi ja ohjeet varauksen vahvistamiseen.
                </>
              )}
            </p>

            <div className="my-4">
              <Link
                to="/palvelut#kuljetuspalvelu"
                className="text-linkcol underline hover:text-accent transition font-customFont1 text-base mb-16 scroll-mt-28"
              >
                📄 Lue lisää kuljetuspalvelusta, vuokrakärrystä ja noutamisesta
              </Link>
            </div>

            <div
              className="grid grid-cols-1 xxxsm:grid-cols-1 xxsm:grid-cols-1 s24:grid-cols-1 xsm:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 mdd:grid-cols-2  lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-4"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              {/* Lomake vasemmalla */}
              <div>
                <form onSubmit={handleFormSubmit}>

                

                  {/* Päivämäärät vain varaus-tilassa */}
                  {autoMessageOption === "reservation" && (
                    <motion.div
                      className="min-h-[80px]"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <RentalDateSelector labelColor="#30F2CF" />
                    </motion.div>
                  )}

                  {/* Peräkärry-lisäkentät (vain reservation + hasTrailer) */}
                  {autoMessageOption === "reservation" && hasTrailer && (
                    <div className="mt-6 p-4 border-t border-gray-300">
                      <h3 className="font-customFont2 text-left text-darkest dark:text-primary dark:text-shadow-lg text-3xl font-bold mb-2">
                        Peräkärryn vuokraus
                      </h3>

                      <div className="mb-4">
                        <label
                          htmlFor="trailerTime"
                          className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg font-bold dark:text-shadow-lg mb-1"
                        >
                          Vuokraus alkaa:
                        </label>
                        <input
                          id="trailerTime"
                          type="time"
                          value={trailerPickupTime}
                          onChange={(e) => {
                            setTrailerPickupTime(e.target.value);
                          }}
                          className="w-full font-customFont1 bg-white dark:bg-darkest dark:text-primary border border-gray-800 rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 focus:ring-primary transition pr-4"
                        />

                        {selectedDates.endDate && (
                          <p className="my-2 font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-sm dark:text-shadow-lg font-light">
                            Valittu palautusaika:{" "}
                            {(() => {
                              const end = new Date(selectedDates.endDate);
                              return `${end.toLocaleDateString("fi-FI", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })} klo ${end.toLocaleTimeString("fi-FI", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                              })}`;
                            })()}
                          </p>
                        )}


                      </div>

                      <div className="mb-4">
                        <label
                          htmlFor="trailerLicensePlate"
                          className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-bold mb-2 dark:text-shadow-lg mt-4"
                        >
                          Vetoauton rekisterinumero:
                        </label>
                        <input
                          id="trailerLicensePlate"
                          type="text"
                          placeholder="ABC-123"
                          pattern="[A-ZÅÄÖ]{2,3}-[0-9]{1,3}"
                          value={trailerLicensePlate}
                          onChange={(e) =>
                            setTrailerLicensePlate(e.target.value.toUpperCase())
                          }
                          className="w-full font-customFont1 bg-white dark:bg-darkest dark:text-primary border border-gray-800 rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 focus:ring-primary transition pr-4 p-2 uppercase"
                        />
                      </div>

                      {/* haluatko toimituksen */}
                      <fieldset className="mb-4">
                        <legend className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base dark:text-shadow-lg font-bold mb-1">
                          Haluatko, että kärry toimitetaan?
                        </legend>
                        <div className="flex items-center space-x-4">
                          <label htmlFor="deliveryOptionPickup" className="flex items-center space-x-2">
                            <input
                              id="deliveryOptionPickup"
                              type="radio"
                              name="deliveryOption"
                              value="pickup"
                              checked={deliveryOption === "pickup"}
                              onChange={() => setDeliveryOption("pickup")}
                              className="form-radio"
                            />
                            <span className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-light">
                              En, noudan itse.
                            </span>
                          </label>

                          <label htmlFor="deliveryOptionDelivery" className="flex items-center space-x-2">
                            <input
                              id="deliveryOptionDelivery"
                              type="radio"
                              name="deliveryOption"
                              value="delivery"
                              checked={deliveryOption === "delivery"}
                              onChange={() => setDeliveryOption("delivery")}
                              className="form-radio"
                            />
                            <span className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-light">
                              Haluan toimituksen
                            </span>
                          </label>
                        </div>
                      </fieldset>

                      <div className="mb-4">
                        <label
                          htmlFor="deliveryAddress"
                          className={
                            "block font-customFont1 text-shadow-lg text-left text-lg xxsm:text-base font-bold mb-1 transition duration-300 pb-1 " +
                            (deliveryOption !== "delivery"
                              ? "text-gray-500 opacity-40 cursor-not-allowed"
                              : "text-primary opacity-100")
                          }
                        >
                          Toimitusosoite:
                        </label>
                        <Autocomplete
                          onLoad={(ref) => (deliveryRef.current = ref)}
                          onPlaceChanged={onPlaceChanged}
                          options={autocompleteOptions}
                        >
                          <input
                            id="deliveryAddress"
                            type="text"
                            placeholder="Anna toimitusosoite..."
                            value={deliveryAddress}
                            onChange={(e) => {
                              setDeliveryAddress(e.target.value);
                              if (e.target.value.trim().length < 3) {
                                setDistance(null);
                                setTravelCost(null);
                              }
                            }}
                            disabled={deliveryOption !== "delivery"}
                            aria-invalid={deliveryRequired && !isValidAddress} // ✅ Oikeassa paikassa, boolean-arvo
                            className={
                              "w-full font-customFont1 border rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 transition pr-4 p-2 " +
                              (deliveryOption !== "delivery"
                                ? "bg-gray-300 cursor-not-allowed text-gray-500 opacity-40 border-gray-800"
                                : !isValidAddress && deliveryRequired
                                  ? "bg-white text-black opacity-100 border-red-500 focus:ring-red-500"
                                  : "bg-white text-black opacity-100 border-gray-800 focus:ring-primary")
                            }
                          />
                        </Autocomplete>

                        {shouldUseTrailerForTransport(cart) && needsTransport && (
                          <p className="text-yellow-400 text-sm mt-2">
                            Kuljetukseen tarvitaan peräkärryä, lisämaksu 20 € / suunta.
                          </p>
                        )}

                        {/* ✅ Näytetään virheilmoitus vain jos kuljetus on valittu JA osoite virheellinen */}
                        {deliveryRequired && !isValidAddress && (
                          <p className="text-red-500 text-sm mt-1">Anna kelvollinen osoite</p>
                        )}

                      </div>
                    </div>
                  )}

                  {autoMessageOption === "reservation" && !hasTrailer && (
                    <div className="mt-6 p-4 border-t border-gray-300">
                      <h3 className="font-customFont2 text-left text-primary dark:text-primary dark:text-shadow-lg text-3xl font-bold mb-2">
                        Laitteiden vuokraus
                      </h3>
                      <div className="mb-4">
                        <label
                          htmlFor="deliveryOptionSelect"
                          className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg font-bold mb-1"
                        >
                          Haluatko, että toimitamme laitteet tapahtumapaikalle?
                        </label>
                        <select
                          id="deliveryOptionSelect"
                          value={deliveryOption}
                          onChange={(e) => {
                            setDeliveryOption(e.target.value);
                            if (e.target.value === "pickup") setDeliveryAddress("");
                          }}
                          className="w-full p-2 rounded-xl bg-white font-customFont1 text-left text-darkest xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light border border-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary transition"
                        >
                          <option value="pickup">En, noudan itse</option>
                          <option value="delivery">Kyllä, haluan toimituksen</option>
                        </select>
                      </div>

                      <div className="mb-4">
                        <label
                          htmlFor="deliveryAddress"
                          className={
                            "block font-customFont1 text-shadow-lg text-left text-lg xxsm:text-base font-bold mb-1 transition duration-300 pb-1 " +
                            (deliveryOption !== "delivery"
                              ? "text-gray-500 opacity-40 cursor-not-allowed"
                              : "text-primary opacity-100")
                          }
                        >
                          Toimitusosoite:
                        </label>
                        <Autocomplete
                          onLoad={(ref) => (deliveryRef.current = ref)}
                          onPlaceChanged={onPlaceChanged}
                          options={autocompleteOptions}
                        >
                          <input
                            id="deliveryAddress"
                            type="text"
                            placeholder="Anna toimitusosoite..."
                            value={deliveryAddress}
                            onChange={(e) => {
                              setDeliveryAddress(e.target.value);
                              if (e.target.value.trim().length < 3) {
                                setDistance(null);
                                setTravelCost(null);
                              }
                            }}
                            disabled={deliveryOption !== "delivery"}
                            aria-invalid={deliveryRequired && !isValidAddress}
                            className={
                              "w-full font-customFont1 border rounded-xl shadow-sm focus:outline-none text-center focus:ring-2 transition pr-4 p-2 " +
                              (deliveryOption !== "delivery"
                                ? "bg-gray-300 cursor-not-allowed text-gray-500 opacity-40 border-gray-800"
                                : !isValidAddress && deliveryRequired
                                ? "bg-white text-black opacity-100 font-customFont1 border-red-500 focus:ring-red-500"
                                : "bg-white text-black opacity-100 font-customFont1 border-gray-800 focus:ring-primary")
                            }
                          />
                        </Autocomplete>

                        {shouldUseTrailerForTransport(cart) && needsTransport && (
                          <p className="text-yellow-400 text-sm mt-2 font-customFont1">
                            Kuljetukseen tarvitaan peräkärryä, lisämaksu 20 € / suunta.
                          </p>
                        )}

                        {deliveryRequired && !isValidAddress && (
                          <p className="text-red-500 text-sm mt-1 font-customFont1">
                            Anna kelvollinen osoite
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Kaksi saraketta: vasen => yhteystiedot, oikea => viesti + submit */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Sarake 1: nimi, sposti, puh, tapahtumapaikka (jos ei trailer), kuljetus (jos ei trailer) */}
                    <div className="space-y-4">
                      <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                      >
                        <label
                          htmlFor="name"
                          className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-bold mb-2"
                        >
                          Nimesi:
                        </label>
                        <motion.input
                          id="name"
                          type="text"
                          placeholder="Etu- ja sukunimi.."
                          value={nimi}
                          onChange={(e) => setNimi(e.target.value)}
                          required
                          whileFocus={{
                            scale: 1.05,
                            transition: {
                              duration: 0.2,
                              type: "spring",
                              stiffness: 300,
                            },
                          }}
                          className="w-full p-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1"
                        />
                      </motion.div>

                      <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <label
                          htmlFor="email"
                          className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-bold mb-2"
                        >
                          Sähköposti:
                        </label>
                        <motion.input
                          id="email"
                          type="email"
                          placeholder="Syötä sähköpostisi.."
                          value={sahkoposti}
                          onChange={(e) => setSahkoposti(e.target.value)}
                          onBlur={(e) => validateEmail(e.target.value)} // tarkistus blurissa
                          required
                          pattern="[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}"
                          title="Anna voimassa oleva sähköpostiosoite"
                          whileFocus={{
                            scale: 1.05,
                            transition: {
                              duration: 0.2,
                              type: "spring",
                              stiffness: 300,
                            },
                          }}
                          className="w-full p-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1"
                        />

                        {/* Virheilmoitus näkyy vain jos virhe on olemassa */}
                        {emailError && (
                          <p className="text-red-500 text-sm mt-1">{emailError}</p>
                        )}
                      </motion.div>

                      <motion.div
                          initial={{ opacity: 0, x: -50 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.5, delay: 0.3 }}
                        >
                          <label
                            htmlFor="puhelinnumero"
                            className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg xxsm:text-base font-bold mb-2"
                          >
                            Puhelinnumero:
                          </label>
                          <motion.input
                          id="puhelinnumero"
                          type="tel"
                          placeholder="Anna puhelinnumero.."
                          value={puhelinnumero}
                          onChange={(e) => setPuhelinnumero(e.target.value)}
                          onBlur={(e) => validatePhone(e.target.value)} // validointi blurilla
                          required
                          pattern="[0-9\s\-\+\(\)]{7,20}" // korjattu pattern!
                          title="Anna voimassa oleva puhelinnumero"
                          whileFocus={{
                            scale: 1.05,
                            transition: {
                              duration: 0.2,
                              type: "spring",
                              stiffness: 300,
                            },
                          }}
                          className="w-full p-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1"
                        />

                          {phoneError && (
                            <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                          )}
                        </motion.div>

                      {autoMessageOption === "reservation" && !hasTrailer && (
                        <motion.div
                          initial={{ opacity: 1 }}
                          animate={{ opacity: 1 }}
                          transition={{ duration: 0.3 }}
                     
                          className="min-h-[70px]"
                        >
                          <label
                            htmlFor="location"
                            className="block font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg font-bold xxsm:text-base mb-2"
                          >
                            Tapahtumapaikka:
                          </label>
                          <Autocomplete
                            onLoad={(ac) => (autocompleteRef.current = ac)}
                            onPlaceChanged={() => {
                              if (autocompleteRef.current) {
                                const place = autocompleteRef.current.getPlace();
                                if (place && place.geometry) {
                                  setTapahtumapaikka(place.formatted_address);
                                }
                              }
                            }}
                            options={autocompleteOptions}
                          >
                            <input
                              id="location"
                              type="text"
                              placeholder="Tapahtumapaikan osoite.."
                              value={tapahtumapaikka}
                              onChange={(e) => setTapahtumapaikka(e.target.value)}
                              className="w-full p-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1"
                            />
                          </Autocomplete>
                        </motion.div>
                      )}

                    </div>

                    <div className="space-y-4">
                      <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, delay: 0.6 }}
                      >
                        <label
                          htmlFor="viesti"
                          className="block font-customFont1 text-shadow-lg xxsm:text-base text-left text-primary dark:text-primary text-lg font-bold mb-1"
                        >
                          Viestisi
                          {hasTrailer && autoMessageOption === "reservation" && (
                            <span className="text-sm xxsm:text-base font-normal italic text-primary">
                              {" "}
                              (valinnainen)
                            </span>
                          )}
                        </label>
                        <motion.textarea
                          id="viesti"
                          placeholder={
                            hasTrailer && autoMessageOption === "reservation"
                              ? "Jos haluat, voit lisätä lisätietoja..."
                              : "Kirjoita viestisi..."
                          }
                          value={viesti}
                          onChange={(e) => setViesti(e.target.value)}
                          rows="4"
                          required={
                            !(hasTrailer && autoMessageOption === "reservation")
                          }
                          whileFocus={{
                            scale: 1.05,
                            transition: {
                              duration: 0.2,
                              type: "spring",
                              stiffness: 300,
                            },
                          }}
                          className="custom-textarea w-full p-2 rounded-full bg-white border-none focus:outline-none text-base font-customFont1"
                        />
                      </motion.div>

                      <div className="my-4 scale-[0.85] origin-left">
                      <RecaptchaField
                        siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        onChange={(val) => setRecaptchaRentalValue(val)}
                        innerRef={recaptchaRef}
                      />

                      </div>

                      {/* {(!maksuSuoritettu && userId && (hasTrailer || calculateTotal() > 100)) && (
                        <div className="my-6">
                          <Elements stripe={stripePromise}>
                            <CheckoutForm
                              userId={userId}
                              nimi={nimi}
                              sahkoposti={sahkoposti}
                              puhelinnumero={puhelinnumero}
                              cart={cart}
                              selectedDates={selectedDates}
                              onSuccess={() => setMaksuSuoritettu(true)}
                              onReservationSaved={(id) => console.log("varausID", id)}
                            />
                          </Elements>
                        </div>
                      )} */}

{autoMessageOption === "reservation" && hasTrailer ? (
  userId && cart.length > 0 && selectedDates?.startDate ? (
    <Elements stripe={stripePromise}>
      <CheckoutForm
        userId={userId}
        nimi={nimi}
        sahkoposti={sahkoposti}
        puhelinnumero={puhelinnumero}
        cart={cart}
        selectedDates={selectedDates}
        onSuccess={() => {
          setMaksuSuoritettu(true);
          // Tyhjennä lomake onnistuneen maksun jälkeen
          setNimi("");
          setSahkoposti("");
          setPuhelinnumero("");
          setTapahtumapaikka("");
          setViesti("");
          setCart([]);
          setDeliveryAddress("");
          setTrailerLicensePlate("");
          localStorage.removeItem("rentalCart");
          localStorage.removeItem("selectedBookingDates");
          localStorage.removeItem("trailerPickupTime");
          window.dispatchEvent(new Event("cartUpdated"));
        }}
        onReservationSaved={(id) => console.log("varausID", id)}
      />
    </Elements>
  ) : (
    <ResponsiveButton type="submit" className="w-full" disabled>
      Täytä ensin tiedot
    </ResponsiveButton>
  )
) : (
  <ResponsiveButton type="submit" className="w-full">
    Lähetä
  </ResponsiveButton>
)}


                    </div>
                  </div>
                </form>
              </div>

              <motion.div
                className="relative backdrop-blur-xl bg-black/30 rounded-2xl shadow-lg p-6 max-w-lg w-full mx-auto mt-4 lg:mt-0"
                initial={{ opacity: 1 }}
                animate={{ opacity: autoMessageOption === "message" ? 0.3 : 1 }}
                transition={{ duration: 0.3 }}
                layout
              >
                <h3 className="font-customFont2 text-left text-primary dark:text-shadow-xxl dark:text-primary text-3xl font-bold mb-4">
                  🛒 Vuokrauskori
                </h3>

                <ul className="space-y-4">
                  {cart.map((item, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center border-b border-white/30 pb-3"
                    >
                      <div className="flex items-center">
                        <p className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light">
                          {item.name}
                        </p>
                        {item.quantity > 1 && (
                          <span className="ml-2 font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light">
                            ({item.quantity}x)
                          </span>
                        )}
                      </div>
                      <div className="flex items-center gap-3">
                        <p className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light whitespace-nowrap">
                          {calculateRentalPrice(
                            selectedDates.startDate,
                            selectedDates.endDate,
                            item.price,
                            item.quantity,
                            item.slug?.toLowerCase().includes("hirvi")
                          ).toFixed(2)}{" "}
                          €
                        </p>
                        <button
                          onClick={() => handleRemoveFromCart(index)}
                          className="bg-teal-500 text-white font-bold w-7 h-7 flex items-center justify-center rounded-full shadow-md transition-all duration-300 ease-in-out transform hover:bg-red-600 hover:scale-110"
                        >
                          <span className="-translate-y-[0.08rem]">&times;</span>
                        </button>
                      </div>
                    </li>
                  ))}

                  {needsTransport && distance && (
                    <li className="flex justify-between items-center border-b border-white/30 pb-3">
                      <span className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-base text-lg font-light">
                        Matka: {distance.toFixed(1)} km
                      </span>
                      <span className="font-customFont1 text-shadow-lg text-left text-primary dark:text-primary xxsm:text-sm text-lg font-light">
                        {shouldUseTrailerForTransport(cart)
                          ? `20€ + ${distance.toFixed(1)} km = ${travelCost} €`
                          : `${distance.toFixed(1)} km = ${travelCost} €`}
                      </span>
                    </li>
                  )}

                </ul>

                <div className="mt-6 flex justify-between items-center font-customFont1 text-shadow-lg text-left text-primary dark:text-primary text-lg font-bold">
                  <p>Yhteensä:</p>
                  <p>
                    {(() => {
                      const rentalTotal = cart.reduce((total, item) => {
                        return (
                          total +
                          calculateRentalPrice(
                            selectedDates.startDate,
                            selectedDates.endDate,
                            item.price,
                            item.quantity,
                            item.slug?.toLowerCase().includes("hirvi")
                          )
                        );
                      }, 0);
                      const transportCost =
                        needsTransport && travelCost
                          ? parseFloat(travelCost)
                          : 0;
                      return (rentalTotal + transportCost).toFixed(2);
                    })()}{" "}
                    €
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </LoadScript>
    </>
  );
};

export default Contactpage;
